import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { EChartsOption } from 'echarts';
import { useI18n } from 'vue-i18n';
import {
    UserDeviceStatusColorMap,
    RealtimeReportServiceGetUserDevicesResult,
    UserDeviceStatus,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDeviceStatusDoughnutChart',
  props: {
    userDevices: { type: Array, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const props = __props;

const connectedUserDeviceStatuses = new Set([
    UserDeviceStatus.CONNECTED,
    UserDeviceStatus.DIALING,
    UserDeviceStatus.RING,
    UserDeviceStatus.RINGING,
    UserDeviceStatus.INUSE,
    UserDeviceStatus.IN_PAUSE,
    UserDeviceStatus.IN_CALL,
]);

const chartOptions = computed<EChartsOption>(() => {
    const connected = props.userDevices.filter((d) =>
        connectedUserDeviceStatuses.has(d.state?.status as UserDeviceStatus),
    ).length;
    const offline = props.userDevices.length - connected;

    const data = [
        {
            value: connected,
            name: t('report.realtime.user.status.connected'),
            itemStyle: {
                color: UserDeviceStatusColorMap[UserDeviceStatus.CONNECTED],
            },
        },
        {
            value: offline,
            name: t('report.realtime.user.status.offline'),
            itemStyle: {
                color: UserDeviceStatusColorMap[UserDeviceStatus.OFFLINE],
            },
        },
    ];

    const title = t('report.realtime.userDeviceStatusDoughnutChart.title');

    const eChartsOption: EChartsOption = {
        title: {
            text: title,
            left: '10px',
            top: '10px',
            textStyle: {
                fontSize: '14px',
                fontWeight: 'normal',
                color: '#555',
            },
        },
        tooltip: {
            trigger: 'item',
        },
        legend: {
            type: 'scroll',
            width: '90%',
            height: '100%',
            bottom: '10px',
            left: 'center',
            itemHeight: 10,
            itemWidth: 10,
            icon: 'circle',
            textStyle: {
                fontSize: '11px',
                lineHeight: 14,
                rich: {
                    a: {
                        align: 'center', // Alinha o texto da legenda horizontalmente ao meio
                        verticalAlign: 'bottom', // Alinha o texto da legenda verticalmente ao meio
                    },
                    b: {
                        align: 'center', // Alinha o valor numérico horizontalmente ao meio
                        verticalAlign: 'bottom', // Alinha o valor numérico verticalmente ao meio
                    },
                },
            },
            selectedMode: true,
            formatter: (name: string) => {
                const value = data.find((d) => d.name == name)?.value || 0;
                return '{a|' + name + '} {b|(' + value + ')}';
            },
        },
        series: [
            {
                type: 'pie',
                radius: ['20%', '55%'],
                data,
                label: {
                    show: true,
                    formatter(param) {
                        return param.name + ' (' + (param.percent || 0) + '%)';
                    },
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };
    return eChartsOption;
});

const __returned__ = { t, props, connectedUserDeviceStatuses, chartOptions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})